// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"style_headerWrapper__hcebl","header":"style_header__2o5bw"};